import { render } from "./MintNftFile.vue?vue&type=template&id=36d98856&scoped=true"
import script from "./MintNftFile.vue?vue&type=script&lang=js"
export * from "./MintNftFile.vue?vue&type=script&lang=js"

import "@/Common/Styles/fileInput.scss?vue&type=style&index=0&id=36d98856&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d98856"]])

export default __exports__